import React, { useEffect, useRef } from "react";
import franceFlag from "../../../../assets/france-flag.png";
import { useNavigate } from "react-router-dom";
import "./userPersonalInformation.scss";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import useFetch from "../../../useFech";

function UserPersonalInformation() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const password = useRef({});
  const email = useRef({});

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message =
        "Are you sure you want to refresh? Your unsaved changes may be lost.";
      event.returnValue = message; // Standard for most browsers
      return message; // For some older browsers
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const navigateToemailConfirmation = () => {
    navigate("/user/emailConfirmation");
  };

  const {
    register,
    handleSubmit,
    watch,
    trigger,
    formState: { errors },
  } = useForm();

  const onSubmit = () => {
    navigateToemailConfirmation();
  };

  password.current = watch("password", "");
  email.current = watch("email", "");

  const next = async () => {
    dispatch({
      type: "NEXT",
    });
  };

  const emailExists = () => {
    if (data !== "") {
      return data;
    }
  };

  const { data, error } = useFetch(
    `https://femez.onrender.com/API/user/users/${email.current}`
  );

  return (
    <div className="userPersonalInformation-div">
      <form onSubmit={handleSubmit(onSubmit)}>
        <h1>Register</h1>
        <label id="name_surname_label">
          {/* <p>Name and Surname</p> */}
          <input
            autoFocus={true}
            type="text"
            id="name_surname"
            placeholder="Name"
            className={`${errors.name_surname && "invalid"}`}
            {...register("name_surname", {
              required: true,
              pattern: /^[A-Za-z\-_\s]+$/i,
              validate: (value) => value.trim().length > 0,
              minLength: 4,
              maxLength: 50,
            })}
          />

          {errors.name_surname && errors.name_surname.type === "required" && (
            <span>This field is required</span>
          )}
          {errors.name_surname && errors.name_surname.type === "pattern" && (
            <span>The name must contain alphabetic characters only</span>
          )}
          {errors.name_surname && errors.name_surname.type === "validate" && (
            <span>The name-surname cannot be empty</span>
          )}
          {errors.name_surname && errors.name_surname.type === "minLength" && (
            <span>
              the Length of the name-surname must be greater than or equal 4
              characters
            </span>
          )}
          {errors.name_surname && errors.name_surname.type === "maxLength" && (
            <span>
              the Length of the name-surname must be less than or equal to 50
              characters
            </span>
          )}
        </label>
        <label>
          {/* <p>Address Email</p> */}
          <input
            {...register("email", {
              required: true,
              pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
              validate: emailExists,
            })}
            type="email"
            id="email"
            placeholder="Address Email"
            className={`${errors.email && "invalid"}`}
          />
          {errors.email && errors.email.type === "required" && (
            <span>This field is required</span>
          )}
          {errors.email && errors.email.type === "pattern" && (
            <span>Invalid email address</span>
          )}
          {errors.email && errors.email.type === "validate" && (
            <span>{errors.email.message}</span>
          )}
        </label>
        <label>
          {/* <p>Phone Number</p> */}
          <div className="phone-input">
            <img
              src={franceFlag}
              height="20px"
              witdh="20px"
              alt="france drapeaux"
            />
            <input
              {...register("phone", {
                required: true,
                pattern: /^[?\d+]+$/i,
              })}
              id="phone"
              type="tel"
              placeholder="Phone Number"
              className={`${errors.phone && "invalid"}`}
              onKeyUp={() => {
                trigger("phone");
              }}
            />
          </div>
          {errors.phone && errors.phone.type === "pattern" && (
            <span>invalid phone number</span>
          )}
          {errors.phone && errors.phone.type === "required" && (
            <span>This field is required</span>
          )}
        </label>
        {/* <hr /> */}
        <label className="password-label">
          {/* <p>Password</p> */}
          <input
            {...register("password", {
              required: true,
              pattern: /^(?=.*[A-Za-z])(?=.*[0-9])(?=.{8,})/,
            })}
            type="Password"
            id="Password"
            placeholder="Password"
            onKeyUp={() => {
              trigger("password");
            }}
            className={`${errors.password && "invalid"}`}
          />
          {errors.password && errors.password.type === "required" && (
            <span>This field is required</span>
          )}
          {errors.password && errors.password.type === "pattern" && (
            <span>
              The password must contain at least (1 character, 1 number, length
              greater or equal 8 character)
            </span>
          )}
        </label>
        <label>
          {/* <p>Confirm your password</p> */}
          <input
            name="password_Confirmation"
            placeholder="Confirm your password"
            type="Password"
            {...register("password_Confirmation", {
              required: true,
              validate: (value) => value === password.current,
            })}
            className={`${errors.password_Confirmation && "invalid"}`}
          />
          {errors.password_Confirmation &&
            errors.password_Confirmation.type === "required" && (
              <span>This field is required</span>
            )}
          {errors.password_Confirmation &&
            errors.password_Confirmation.type === "validate" && (
              <span>The passwords do not match</span>
            )}
        </label>

        <input type="submit" value="Next" onClick={next} id="submit" />
      </form>
    </div>
  );
}

export default UserPersonalInformation;
